<template>
  <!-- 设备管理-->
 <div>

   <div class="searchBox" ref="searchBox">

     <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px" size="mini">
       <div class=" inpBox">
         <el-form-item label="" prop="regionId" style="display: none;">
           <el-input  placeholder="" maxlength="30" v-model="searchFrom.regionId"></el-input>
         </el-form-item>

       </div>
       <div class="searchBtnBox" >

         <el-form-item>
           <h3 ref="shangjiName">查看设备</h3>
           <el-button type="primary"  @click="goOff()">返回</el-button>
           <el-button type="primary"  @click="addRegion">新增</el-button>
          </el-form-item>
         <!--  <el-form-item>
            <el-button type="danger"   @click="delDeiver">删除</el-button>
          </el-form-item>-->
         <!--<el-form-item>
           <el-button type="primary" @click="searchFn">查询</el-button>
         </el-form-item>
         &nbsp;
         <el-form-item>
           <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
         </el-form-item>-->
       </div>
     </el-form>
   </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
       <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick" height="100%" style="width: 100%" center>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="deviceName" label="设备名称"></el-table-column>
        <el-table-column prop="deviceNumber" label="设备序列号"></el-table-column>
         <el-table-column prop="deviceModel" label="型号"></el-table-column>
         <el-table-column prop="warningFlag" label="是否预警"  align="center">
           <template slot-scope="scope">
             <div>
              <span v-if="scope.row.warningFlag=='1'">
                不预警
              </span>
             <span v-else-if="scope.row.warningFlag=='2'">
                预警
              </span>
              </div>
           </template>
         </el-table-column>
         <el-table-column prop="deviceType" label="类型"  align="center">
           <template slot-scope="scope">
             <div>
              <span v-if="scope.row.deviceType=='1'">
                不可调节
              </span>
             <span v-else-if="scope.row.deviceType=='0'">
                可调节
              </span>
              </div>
           </template>
         </el-table-column>

         <el-table-column prop="stateFlg" label="状态"  align="center">
           <template slot-scope="scope">
             <div>
              <span v-if="scope.row.stateFlg=='1'">
                关闭
              </span>
             <span v-else-if="scope.row.stateFlg=='0'">
                开启
              </span>
              </div>
           </template>
         </el-table-column>
         <el-table-column label="操作">
           <template slot-scope="scope">
             <div>
             <el-button type="text" size="mini" @click="suspension(scope.row)" v-if="scope.row.stateFlg=='1'">开启</el-button>
             <el-button type="text" size="mini" @click="suspension(scope.row)" v-if="scope.row.stateFlg=='0'">关闭</el-button>
             <el-button type="text" size="mini" @click="modifyRegion(scope.row)">编辑</el-button>
             <el-button type="text" size="mini"  v-if="scope.row.stateFlg=='0'" disabled>删除</el-button>
             <el-button type="text" size="mini" @click="deleteDevice(scope.row)" v-if="scope.row.stateFlg=='1'" >删除</el-button>
             </div>
           </template>
         </el-table-column>
       </el-table>
    </div>
   <!-- 分页 -->
   <div>
     <el-pagination background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchFrom.pageNo"
                    :page-sizes="[25,50,100]"
                    :page-size="searchFrom.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
     </el-pagination>
   </div>
    <!-- 新建修改 -->
    <el-dialog  :title="title"  :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false" :close-on-press-escape="false" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline jiaoyan" label-width="110px" size="mini">
        <div class="inpBox">
               <el-form-item label="设备名称:" prop="deviceName">
                <el-input  placeholder="" maxlength="32" v-model.trim="addFrom.deviceName"></el-input>
              </el-form-item>
              <el-form-item label="设备序列号:" prop="deviceNumber">
                <el-input  placeholder="" maxlength="64" v-model.trim="addFrom.deviceNumber"></el-input>
              </el-form-item>
              <el-form-item label="设备型号:" prop="deviceModel">
                <el-input  placeholder="" maxlength="32" v-model.trim="addFrom.deviceModel"></el-input>
              </el-form-item>
              <el-form-item label="设备安全码:" prop="remark">
                <el-input  placeholder="" maxlength="12" v-model.trim="addFrom.remark" :readonly="updateRead"></el-input>
              </el-form-item>
               <el-form-item label="是否预警:" prop="warningFlag">
                  <template>
                    <el-radio v-model="addFrom.warningFlag" label="1">不预警</el-radio>
                    <el-radio v-model="addFrom.warningFlag" label="2">预警</el-radio>
                  </template>
              </el-form-item>
              <el-form-item label="" prop="">
                <span style="font-size: 9px">设备安全码：1，设备初始化后的设备密码。2，设备底部标签中（或二维码中）数字的安全码。3以上二者都没有则不填。</span>
              </el-form-item>
             <el-form-item label="是否可调节:" prop="deviceType">
                  <template>
                    <el-radio v-model="addFrom.deviceType" label="0">可调节</el-radio>
                    <el-radio v-model="addFrom.deviceType" label="1">不可调节</el-radio>
                  </template>
              </el-form-item>

              <el-form-item label="所属库区:" prop="regionName">
                <span >{{regionNameSpan}}</span>
              </el-form-item>
                <span  ref="regionIdSpan" style="display: none;">{{regionIdSpan}}</span>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>

 </div>
</template>

<script>
import { encryption } from '@/utils/util'
import { aDevicelist, aDeviceClose, aDeviceDel, aDeviceAdd, aDeviceupdate } from '@/api/video'
export default {
  data () {
    return {
      h: '500px',
      updateRead: false,
      title: '新建',
      dialogVisible: false,
      dialogAppSecret: false,
      checkList: [],
      tableList: [],
      loading: 'false',
      ids: [],
      rules: {
        deviceName: [
          { required: true, message: '请输入设备名称', trigger: 'blur' }
        ],
        deviceNumber: [
          { required: true, message: '请输入序列号', trigger: 'blur' }
        ],
        deviceModel: [
          { required: true, message: '请输入型号', trigger: 'blur' }
        ],
        warningFlag: [
          { required: true, message: '请选择是否预警', trigger: 'blur' }
        ],
        deviceType: [
          { required: true, message: '请选择是否可调节', trigger: 'blur' }
        ]
      },
      regionNameSpan: '',
      regionIdSpan: '',
      addFrom: {
        regionName: '',
        regionId: ''
      },
      searchFrom: {
        pageNo: 1,
        pageSize: 25,
        regionId: this.$route.query.regionId
      },
      total: 0,
      options: [
        {
          value: '0',
          label: '启用'
        },
        {
          value: '1',
          label: '停用'
        }]
    }
  },
  created () {
    this.regionNameSpan = this.$route.query.regionName
    this.regionIdSpan = this.$route.query.regionId
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 92) + 'px'
  },
  methods: {
    goOff () {
      this.$router.go(-1)
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      aDevicelist(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 重置
    resetForm (formName) {
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 25,
        createTime: null
      }
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 添加
    addRegion () {
      this.title = '新建'
      this.addFrom = { warningFlag: '1' }
      this.dialogVisible = true
      this.isAdd = true
      this.updateRead = false
    },
    // 修改
    modifyRegion (row) {
      this.addFrom = JSON.parse(JSON.stringify(row))
      this.title = '修改'
      this.dialogVisible = true
      this.isAdd = false
      this.updateRead = true
    },
    saveFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addFrom.regionId = this.$refs.regionIdSpan.innerHTML
          if (this.isAdd) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            aDeviceAdd(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            aDeviceupdate(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        } else {
          return false
        }
      })
    },
    // 停用/启用
    suspension (row) {
      this.$confirm('是否执行此操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        aDeviceClose({ id: row.id }).then(res => {
          loading.close()

          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 删除
    deleteDevice (row) {
      const selectData = this.$refs.table.selection
      if (row.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        /* this.id = []
        selectData.some(item => {
          this.ids.push(item.id)
        }) */
        this.$confirm('是否执行删除操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          aDeviceDel({ id: row.id }).then(res => {
            loading.close()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(() => {

        })
      }
    },
    // 查看秘钥
    seeAppSecretFrame (row) {
      this.title = '查看秘钥'
      this.addFrom2.id = row.id
      this.dialogAppSecret = true
    },
    // 查看秘钥
    seeAppSecret (row) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      let Authorization1 = encryption({
        data: { Basic: this.addFrom2.password },
        type: 'Base64',
        param: ['Basic']
      })
      aParcheckPwd(
        {
          password: this.addFrom2.password,
          id: this.addFrom2.id
        }
      ).then(res => {
        if (res == false) {
          this.$alert('密码有误', '查看秘钥', { center: true })
        } else {
          this.$alert(res.appSecret, '查看秘钥', { center: true })
          this.dialogAppSecret = false
        }
        loading.close()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    closeDialog () {
      if (this.$refs.addFrom !== undefined) {
        this.$refs.addFrom.resetFields()
      }
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        seconds
      )
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>
<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
</style>
